// TicketDist.js
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {
  Grid,
  Typography,
  Button,
  Paper,
  Divider,
  Box,
} from '@mui/material';
import { findOneTicket } from '../services/ticket.service';
import Barcode from 'react-barcode';

export default function TicketDist() {
  const location = useLocation();
  const history = useHistory();
  const otgIds = useMemo(() => location.state?.ids_otg || [], [location.state]);
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const refs = useRef([]);

  useEffect(() => {
    const fetchAllTickets = async () => {
      try {
        const results = await Promise.all(
          otgIds.map((id) => findOneTicket(id).then((res) => res.data))
        );
        setTickets(results);
      } catch (err) {
        console.error('Error al cargar tickets:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAllTickets();
  }, [otgIds]);

  // Función para imprimir un ticket
  const imprimirTicket = (index) => {
    const printContents = refs.current[index]?.innerHTML;
    const win = window.open('', '_blank');
    win.document.write(`
      <html>
        <head>
          <title>Ticket OTG</title>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
                display: flex;
                justify-content: center;
              }

              .ticket-wrapper {
                width: 80mm;
                padding: 10px;
                font-family: 'Courier New', monospace;
                font-size: 12px;
                line-height: 1.3;
                text-align: left;
                page-break-after: always;
                font-weight: bold;
              }

              h2, h6, p, div {
                margin: 2px 0;
              }

              @page {
                size: auto;
                margin: 8mm;
              }
            }
          </style>
        </head>
        <body>
          <div class="ticket-wrapper">${printContents}</div>
        </body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  // Función para imprimir todos los tickets
  const imprimirTodos = () => {
    const printContents = refs.current
      .map(ref => `<div class="ticket-wrapper">${ref?.innerHTML}</div>`)
      .join('');
    const win = window.open('', '_blank');
    win.document.write(`
      <html>
        <head>
          <title>Tickets OTG</title>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 0;
                display: flex;
                flex-direction: column;
                align-items: center;
              }

              .ticket-wrapper {
                width: 80mm;
                padding: 10px;
                font-family: 'Courier New', monospace;
                font-size: 12px;
                line-height: 1.3;
                text-align: left;
                page-break-after: always;
                font-weight: bold;
                box-sizing: border-box;
              }

              h2, h6, p, div {
                margin: 2px 0;
              }

              @page {
                size: auto;
                margin: 8mm;
              }
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  if (loading) return <Typography variant="body1">Cargando tickets...</Typography>;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Tickets Generados: {tickets.length}
      </Typography>

      

      <Grid container spacing={4}>
        {tickets.map((ticket, index) => (
          <Grid item xs={12} md={6} key={ticket.id_otg}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                border: '1px dashed #000',
                fontFamily: 'Courier New, monospace',
                fontSize: '12px',
                lineHeight: 1.3,
                fontWeight: 'bold',
                textAlign: 'left',
              }}
              ref={(el) => (refs.current[index] = el)}
              className="ticket"
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ fontWeight: 'bold', textTransform: 'uppercase', mb: 2 }}
              >
                OTG CANAL MAYOR
              </Typography>

              <Typography variant="subtitle1" gutterBottom>
                Ticket Nro. {index + 1} de {tickets.length}
              </Typography>

              <Box display="flex" justifyContent="center" my={2}>
                <Barcode value={ticket.id_otg.toString()} />
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography><strong>Producto:</strong> {ticket.Variacion.nombre_producto}</Typography>
              <Typography>
                <strong>Cliente:</strong>{' '}
                {`${ticket.Cliente.primer_nombre} ${ticket.Cliente.segundo_nombre || ''} ${ticket.Cliente.ap_paterno} ${ticket.Cliente.ap_materno}`}
              </Typography>
              <Typography><strong>Origen:</strong> {ticket.ubiOrigen.nombre_ubicacion}</Typography>
              <Typography><strong>Fecha:</strong> {new Date(ticket.createdAt).toLocaleDateString()}</Typography>

              <Divider sx={{ my: 2 }} />

              <Typography variant="subtitle1" gutterBottom>INFORMACIÓN</Typography>
              {ticket.Servicios.map((s, i) => (
                <Box key={i} sx={{ mb: 1 }}>
                  <Typography>- <strong>Falla:</strong> {s.Falla.nombre_falla}</Typography>
                  <Typography>  <strong>Tipo:</strong> {s.tipo_servicio}</Typography>
                </Box>
              ))}
            </Paper>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
              <Button
                variant="contained"
                onClick={() => imprimirTicket(index)}
                sx={{
                  backgroundColor: '#000',
                  color: '#fff',
                  '&:hover': { backgroundColor: '#333' },
                }}
              >
                Imprimir
              </Button>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
